import React, { useContext } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Shipping from '../../cart/Shipping';
import CartContext from '../../../../contexts/CartContext';
import ConfigContext from '../../../../contexts/ConfigContext';

// Trim the configured shipping codes down to the two we actually offer:
// PICKUP + a synthetic STANDARD. STANDARD is resolved client-side at fetch
// time to whichever non-PICKUP option the backend returns — that way the
// radio always points at a code the backend supports, regardless of which
// specific carrier code (CP.RP, ARMOUR, etc.) is configured.
// LOCAL is excluded (no longer offered).
const filterShippingOptions = (options: string[]): string[] => {
  const result: string[] = [];
  if (options.includes('PICKUP')) result.push('PICKUP');
  if (options.some(o => o !== 'PICKUP' && o !== 'LOCAL')) result.push('STANDARD');
  return result;
};

const DeliveryOptions = () => {
  const {cart, setCartState} = useContext(CartContext);
  const {config} = useContext(ConfigContext);

  const shippingOptions = filterShippingOptions(config.general.shipping ?? []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCartState({
      ...cart,
      shippingMethod: (event.target as HTMLInputElement).value,
    });
  };

  return (
    <Card className='delivery-options'>
      <CardContent>
        <FormControl component="fieldset">
          <FormLabel component="legend">Delivery Options</FormLabel>
          <RadioGroup aria-label="delivery" name="delivery" value={cart.shippingMethod ?? ''} onChange={handleChange}>
            {shippingOptions.map((option: string) => (
              <Shipping key={option} items={Object.values(cart.items)} radio={true} method={option} alwaysVisible={true}/>
            ))}
          </RadioGroup>
        </FormControl>
      </CardContent>
    </Card>
  )
}

export default DeliveryOptions
